export const notValid = (value) => {
  return value == null || value == undefined;
};

export const checkArray = (ds) => {
  return !notValid(ds) && Array.isArray(ds);
};

export const mergeObjects = (obj1, obj2, keyCount = 'so_luong') => {
  const result = { ...obj1 };
  for (const key in obj2) {
    if (obj2.hasOwnProperty(key)) {
      if (result[key]) {
        result[key] = {
          ...result[key],
          [keyCount]: (result[key][keyCount] || 0) + (obj2[key][keyCount] || 0)
        };
      } else {
        result[key] = { ...obj2[key] };
      }
    }
  }
  return result;
};
export const listToTree = (items, id = null, parent_key, key, keyChildren = 'children') => {
  return items
    .filter(item => item[parent_key] == id)
    .map(item => ({
      ...item,
      [keyChildren]: listToTree(items, item[key], parent_key, key, keyChildren),
      key: item[key]
    }));
}

export const toRoman = (num) => {
  const romanNumerals = [
    { value: 1000, symbol: 'M' },
    { value: 900, symbol: 'CM' },
    { value: 500, symbol: 'D' },
    { value: 400, symbol: 'CD' },
    { value: 100, symbol: 'C' },
    { value: 90, symbol: 'XC' },
    { value: 50, symbol: 'L' },
    { value: 40, symbol: 'XL' },
    { value: 10, symbol: 'X' },
    { value: 9, symbol: 'IX' },
    { value: 5, symbol: 'V' },
    { value: 4, symbol: 'IV' },
    { value: 1, symbol: 'I' }
  ];

  let roman = '';
  for (const { value, symbol } of romanNumerals) {
    while (num >= value) {
      roman += symbol;
      num -= value;
    }
  }
  return roman;
};

export function removeAccents(str) {

  var AccentsMap = [
    "aàảãáạăằẳẵắặâầẩẫấậ",
    "AÀẢÃÁẠĂẰẲẴẮẶÂẦẨẪẤẬ",
    "dđ", "DĐ",
    "eèẻẽéẹêềểễếệ",
    "EÈẺẼÉẸÊỀỂỄẾỆ",
    "iìỉĩíị",
    "IÌỈĨÍỊ",
    "oòỏõóọôồổỗốộơờởỡớợ",
    "OÒỎÕÓỌÔỒỔỖỐỘƠỜỞỠỚỢ",
    "uùủũúụưừửữứự",
    "UÙỦŨÚỤƯỪỬỮỨỰ",
    "yỳỷỹýỵ",
    "YỲỶỸÝỴ"
  ];
  for (var i = 0; i < AccentsMap.length; i++) {
    var re = new RegExp('[' + AccentsMap[i].substr(1) + ']', 'g');
    var char = AccentsMap[i][0];
    str = str.replace(re, char);
  }
  return str;
}

export const percentValue = (value1, value2) => {
  const percent = (value2 || 0) > 0 ? value1 / value2 * 100 : 0

  return percent.toFixed(2)

}

export const convertToNegative = (number) => {
  return number > 0 ? -number : number; // Nếu số dương, trả về giá trị âm
}

export const CAPDULIEU = [
  { name: 'Sở giáo dục', value: 'so' },
  { name: 'Phòng giáo dục', value: 'phong' },
  { name: 'Trường học', value: 'truong' },
]